import axios from 'axios';

export default {
    search(searchTerm, type, offset) {
        let url = '/full-search?search_term=' + searchTerm;

        if (type) {
            url += '&type=' + type + '&offset=' + offset
        }

        var options = {
            method: 'GET',
            baseURL: window.apiUrl,
            url: url,
            headers: {
                'Authorization': 'Bearer ' + localStorage.token
            }
        };
        return axios.request(options).then(response => {
            if (!response.data.success) {
                throw new Error(response.data.error);
            }
            return response.data;
        });
    },

}



// WEBPACK FOOTER //
// ./src/services/search/index.js